import { pipe } from "fp-ts/es6/function"
import * as Ord from "fp-ts/es6/Ord"
import { Newtype, prism } from "newtype-ts"
import {
  Dimension,
  numberAsValidNumber,
  UnitNoDim,
  unsafeFromSome,
  validNumber,
  valueInUnit,
  ValueWithUnit,
  valueWithUnit,
} from "@fitnesspilot/data-common"

const validNumberAsPercent = valueInUnit(Dimension.noDim, UnitNoDim.percent)
const numberAsPercent = numberAsValidNumber.composeIso(validNumberAsPercent)
const percent = valueWithUnit(Dimension.noDim, UnitNoDim.percent, validNumber)

export type Intensity = Newtype<
  { readonly Intensity: unique symbol },
  ValueWithUnit<Dimension.noDim, UnitNoDim.percent>
>
export const intensity: Ord.Ord<Intensity> = percent as any
export const percentAsIntensity = prism<Intensity>(
  Ord.between(percent)(
    pipe(0, numberAsPercent.getOption, unsafeFromSome),
    pipe(100, numberAsPercent.getOption, unsafeFromSome),
  ),
)
export const validNumberAsIntensity =
  validNumberAsPercent.composePrism(percentAsIntensity)
export const numberAsIntensity =
  numberAsPercent.composePrism(percentAsIntensity)
